// Tap-to-copy discount ticket — ONE element for every surface (collection
// strip, clearance tile, PDP coupon ribbon, cart ticket, drawer floor ticket).
// The code is NEVER auto-applied — copying is the whole interaction (locked
// decision). The label flips to "Copied ✓" for 1.6s; clipboard failures still
// flip the label so the customer knows the tap registered and can select the
// text manually. Ported from Lettoria's element, same contract:
//   <skullette-copy-code data-code="X"><span ref-copy-label>…</span></skullette-copy-code>
class SkulletteCopyCode extends HTMLElement {
  connectedCallback() {
    this.label = this.querySelector('[ref-copy-label]');
    this.addEventListener('click', () => this.copy());
  }

  copy() {
    const code = this.getAttribute('data-code') || '';
    const done = () => this.flash();
    if (navigator.clipboard && code) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      done();
    }
  }

  flash() {
    if (!this.label) return;
    const idle = this.label.getAttribute('data-idle-label') || this.label.textContent;
    this.label.setAttribute('data-idle-label', idle);
    this.label.textContent = 'Copied ✓';
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.label.textContent = idle;
    }, 1600);
  }
}

if (!customElements.get('skullette-copy-code')) {
  customElements.define('skullette-copy-code', SkulletteCopyCode);
}
